// // Modelo de datos para Rol
// export class Productos {
//   constructor(data = {}) {
//     console.log('🔍 Producto constructor - data recibido:', data);
//     console.log('🔍 Producto constructor - keys disponibles:', Object.keys(data));
    
//     // ✅ MAPEO CORRECTO PARA TU API (minúsculas primero)
//     this.Id_producto = data.id_producto || data.Id_producto || 0;
//     this.Nombre_producto = data.nombre_producto || data.Nombre_producto || '';
//     this.Descripcion = data.descripcion || data.Descripcion || '';
//     this.Precio = data.precio || data.Precio || 0;    
//     this.Estado = data.estado || data.Estado || 'ACTIVO';
//     this.Id_categoria = data.id_categoria || data.Id_categoria || 0;
//     this.Id_sucursal = data.id_sucursal || data.Id_sucursal || 0;
//     this.ImagenFile = data.imagenFile || data.ImagenFile || '';
//     this.Nombre_categoria = data.nombre_categoria || data.Nombre_categoria || '';
//     this.Nombre_sucursal = data.nombre_sucursal || data.Nombre_sucursal || '';
//     this.Nombre_empresa = data.nombre_empresa || data.Nombre_empresa || '';
    
    
//     console.log('🔍 Producto constructor - objeto creado:', {
//       Id_producto: this.Id_producto,
//       Nombre_producto: this.Nombre_producto,
//       Descripcion: this.Descripcion,
//       Precio: this.Precio,
//       Estado: this.Estado,
//       Id_categoria: this.Id_Id_categoriasucursal,
//       Id_sucursal: this.Id_sucursal,
//       ImagenFile: this.ImagenFile,
//       Nombre_categoria: this.Nombre_categoria,
//       Nombre_sucursal: this.Nombre_sucursal,
//       Nombre_empresa: this.Nombre_empresa
//     });
    
//     if (data instanceof Productos) {
//         this.Id_producto = data.Id_producto;
//         this.Nombre_producto = data.Nombre_producto;
//         this.Descripcion = data.Descripcion;
//         this.Precio = data.Precio;
//         this.Estado = data.Estado;
//         this.Id_categoria = data.Id_categoria;
//         this.Id_sucursal = data.Id_sucursal;
//         this.ImagenFile = data.ImagenFile;
//         this.Nombre_categoria = data.Nombre_categoria;
//         this.Nombre_sucursal = data.Nombre_sucursal;
//         this.Nombre_empresa = data.Nombre_empresa;
//     } else {
//         // Mapeo normal para datos de API
//         this.Id_producto = data.id_producto ?? data.Id_producto ?? null;
//         this.Nombre_producto = data.nombre_producto ?? data.Nombre_producto ?? '';
//         this.Descripcion = data.descripcion ?? data.Descripcion ?? '';
//         this.Precio = data.precio ?? data.Precio ?? null;
//         this.Estado = data.estado ?? data.Estado ?? 'ACTIVO';
//         this.Id_categoria = data.id_categoria ?? data.Id_categoria ?? null;
//         this.Id_sucursal = data.id_sucursal ?? data.Id_sucursal ?? null;
//         this.ImagenFile = data.imagenFile ?? data.ImagenFile ?? '';
//         this.Nombre_categoria = data.nombre_categoria ?? data.Nombre_categoria ?? '';
//         this.Nombre_sucursal = data.nombre_sucursal ?? data.Nombre_sucursal ?? '';
//         this.Nombre_empresa = data.nombre_empresa ?? data.Nombre_empresa ?? '';
//         } 
//     // ✅ VALIDAR QUE SE MAPEARON CORRECTAMENTE
//     if (this.Id_producto === null) {
//       console.warn('⚠️ ADVERTENCIA: Id_producto no se pudo mapear. Data original:', data);
//     }
//     if (!this.Nombre_producto) {
//       console.warn('⚠️ ADVERTENCIA: Nombre_producto no se pudo mapear. Data original:', data);
//     }
//   }

//   // Validaciones
//   isValid() {
//     return this.Nombre_producto.trim() !== '';
//   }

//   // ✅ MÉTODO PARA PUT/POST - AJÚSTALO SEGÚN EL FORMATO QUE ESPERA TU API
//   toApiFormat() {
//     return {
//       id_producto: this.Id_producto,
//       nombre_producto: this.Nombre_producto,
//       descripcion: this.Descripcion,
//       precio: this.Precio,
//       estado: this.Estado,
//       id_categoria: this.Id_Id_categoriasucursal,
//       id_sucursal: this.Id_sucursal,
//       imagenFile: this.ImagenFile,
//       nombre_categoria: this.Nombre_categoria,
//       nombre_sucursal: this.Nombre_sucursal,
//       nombre_empresa: this.Nombre_empresa
//     };
//   }

// toCreateFormat() {
//   return {
      
//       nombre_producto: this.Nombre_producto,
//       descripcion: this.Descripcion,
//       precio: this.Precio,
//       estado: this.Estado,
//       id_categoria: this.Id_Id_categoriasucursal,
//       id_sucursal: this.Id_sucursal,
//       imagenFile: this.ImagenFile,
//       nombre_categoria: this.Nombre_categoria,
//       nombre_sucursal: this.Nombre_sucursal,
//       nombre_empresa: this.Nombre_empresa
//   };
// }

//   // ✅ MÉTODO PARA DEBUG MEJORADO
//   toDebug() {
//     return {
//       'Frontend (mayúsculas)': {
//         Id_producto: this.Id_producto,
//         Nombre_producto: this.Nombre_producto,
//         Descripcion: this.Descripcion,
//         Precio: this.Precio,
//         Estado: this.Estado,
//         Id_categoria: this.Id_Id_categoriasucursal,
//         Id_sucursal: this.Id_sucursal,
//         ImagenFile: this.ImagenFile,
//         Nombre_categoria: this.Nombre_categoria,
//         Nombre_sucursal: this.Nombre_sucursal,
//         Nombre_empresa: this.Nombre_empresa
//       },
//       'API Format (minúsculas)': this.toApiFormat(true),
//       'Is Valid': this.isValid()
//     };
//   }
// }

/* export class Productos {
  constructor(data = {}) {
    // Normalizar las claves de entrada (mayúsculas y minúsculas)
    const normalizedData = this.normalizeKeys(data);
    
    this.Id_producto = normalizedData.id_producto || normalizedData.Id_producto || '';
    this.Nombre_producto = normalizedData.nombre_producto || normalizedData.Nombre_producto || '';
    this.Descripcion = normalizedData.descripcion || normalizedData.Descripcion || '';
    this.Precio = normalizedData.precio || normalizedData.Precio || '';
    this.Imagen = normalizedData.imagen || normalizedData.Imagen || '';
    this.ImagenFile = normalizedData.imagenFile || normalizedData.ImagenFile || null;
    this.Estado = normalizedData.estado || normalizedData.Estado || 'ACTIVO';
    this.Id_categoria = normalizedData.id_categoria || normalizedData.Id_categoria || '';
    this.Id_sucursal = normalizedData.id_sucursal || normalizedData.Id_sucursal || '';
    this.Nombre_categoria = normalizedData.nombre_categoria || normalizedData.Nombre_categoria || '';
    this.Nombre_sucursal = normalizedData.nombre_sucursal || normalizedData.Nombre_sucursal || '';
    this.Nombre_empresa = normalizedData.nombre_empresa || normalizedData.Nombre_empresa || '';
    this.Fecha = normalizedData.fecha || normalizedData.Fecha || '';
    this.Hora = normalizedData.hora || normalizedData.Hora || '';
  }

  normalizeKeys(data) {
    if (!data) return {};
    
    const normalized = {};
    for (const [key, value] of Object.entries(data)) {
      normalized[key.toLowerCase()] = value;
      normalized[key] = value; // Mantener original también
    }
    return normalized;
  }

  // Para mostrar en consola (debug)
  toDebug() {
    return {
      Id_producto: this.Id_producto,
      Nombre_producto: this.Nombre_producto,
      Descripcion: this.Descripcion,
      Precio: this.Precio,
      Imagen: this.Imagen ? `[${this.Imagen.length} caracteres]` : 'Sin imagen',
      ImagenFile: this.ImagenFile ? 'Archivo presente' : 'Sin archivo',
      Estado: this.Estado,
      Id_categoria: this.Id_categoria,
      Id_sucursal: this.Id_sucursal,
      Nombre_categoria: this.Nombre_categoria,
      '🔍 API_FORMAT': {
        imagenFile: this.Imagen ? `[${this.Imagen.length} caracteres para API]` : 'null para API',
        imagen: 'null para API'
      }
    };
  }

  // Para enviar al API (formato minúsculas)
  toApiFormat() {
    return {
      nombre_producto: this.Nombre_producto,
      descripcion: this.Descripcion,
      precio: parseFloat(this.Precio) || 0,
      imagen: this.Imagen,
      imagenFile: this.ImagenFile,
      estado: this.Estado,
      id_categoria: parseInt(this.Id_categoria) || null,
      id_sucursal: parseInt(this.Id_sucursal) || null
    };
  }

  // Para crear (formato minúsculas sin ID)
  toCreateFormat() {
    return {
      nombre_producto: this.Nombre_producto,
      descripcion: this.Descripcion,
      precio: parseFloat(this.Precio) || 0,
      imagen: this.Imagen,
      imagenFile: this.ImagenFile,
      estado: this.Estado,
      id_categoria: parseInt(this.Id_categoria) || null,
      id_sucursal: parseInt(this.Id_sucursal) || null
    };
  }

  // Validar datos
  isValid() {
    return !!(
      this.Nombre_producto && 
      this.Precio && 
      this.Id_categoria && 
      this.Id_sucursal
    );
  }

  // Generar URL de imagen desde base64
  getImageUrl() {
    if (!this.Imagen) return null;
    
    // Si ya es una URL, devolverla directamente
    if (this.Imagen.startsWith('data:') || this.Imagen.startsWith('http')) {
      return this.Imagen;
    }
    
    // Asumir que es base64 y crear data URL
    return `data:image/jpeg;base64,${this.Imagen}`;
  }

  // Establecer imagen desde archivo
  setImageFromFile(file) {
    return new Promise((resolve, reject) => {
      if (!file) {
        this.ImagenFile = null;
        this.Imagen = '';
        resolve();
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target.result.split(',')[1]; // Remover el prefijo data:image/...;base64,
        this.Imagen = base64;
        this.ImagenFile = file;
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
} */


  export class Productos {
  constructor(data = {}) {
    // Normalizar las claves de entrada (mayúsculas y minúsculas)
    const normalizedData = this.normalizeKeys(data);
    
    this.Id_producto = normalizedData.id_producto || normalizedData.Id_producto || '';
    this.Nombre_producto = normalizedData.nombre_producto || normalizedData.Nombre_producto || '';
    this.Descripcion = normalizedData.descripcion || normalizedData.Descripcion || '';
    this.Precio = normalizedData.precio || normalizedData.Precio || '';
    this.Imagen = normalizedData.imagen || normalizedData.Imagen || '';
    this.ImagenFile = normalizedData.imagenFile || normalizedData.ImagenFile || null;
    this.Estado = normalizedData.estado || normalizedData.Estado || 'ACTIVO';
    this.Id_categoria = normalizedData.id_categoria || normalizedData.Id_categoria || '';
    this.Id_sucursal = normalizedData.id_sucursal || normalizedData.Id_sucursal || '';
    this.Nombre_categoria = normalizedData.nombre_categoria || normalizedData.Nombre_categoria || '';
    this.Nombre_sucursal = normalizedData.nombre_sucursal || normalizedData.Nombre_sucursal || '';
    this.Nombre_empresa = normalizedData.nombre_empresa || normalizedData.Nombre_empresa || '';
    this.Fecha = normalizedData.fecha || normalizedData.Fecha || '';
    this.Hora = normalizedData.hora || normalizedData.Hora || '';
  }

  normalizeKeys(data) {
    if (!data) return {};
    
    const normalized = {};
    for (const [key, value] of Object.entries(data)) {
      normalized[key.toLowerCase()] = value;
      normalized[key] = value; // Mantener original también
    }
    return normalized;
  }

  // Para mostrar en consola (debug)
  toDebug() {
    return {
      Id_producto: this.Id_producto,
      Nombre_producto: this.Nombre_producto,
      Descripcion: this.Descripcion,
      Precio: this.Precio,
      Imagen: this.Imagen ? `[${this.Imagen.length} caracteres]` : 'Sin imagen',
      ImagenFile: this.ImagenFile ? 'Archivo presente' : 'Sin archivo',
      Estado: this.Estado,
      Id_categoria: this.Id_categoria,
      Id_sucursal: this.Id_sucursal,
      Nombre_categoria: this.Nombre_categoria,
      '🔍 PARA_API': {
        imagenFile: this.ImagenFile ? 'Se enviará como FormData' : 'NULL',
        imagen: 'NO se envía al API (solo se usa para preview)'
      }
    };
  }

  // ❌ MÉTODO REMOVIDO - NO USAR PARA C# API
  // Este método enviaba datos JSON, pero C# espera FormData
  // El ProductoService ahora maneja la creación del FormData directamente
  
  // ❌ MÉTODO REMOVIDO - NO USAR PARA C# API  
  // Este método enviaba datos JSON, pero C# espera FormData
  // El ProductoService ahora maneja la creación del FormData directamente

  // ✅ MÉTODO PARA VALIDAR DATOS ANTES DEL ENVÍO
  isValid() {
    return !!(
      this.Nombre_producto && 
      this.Precio && 
      this.Id_categoria && 
      this.Id_sucursal
    );
  }

  // ✅ MÉTODO PARA OBTENER DATOS BÁSICOS (sin imagen)
  getBasicData() {
    return {
      id_producto: this.Id_producto,
      nombre_producto: this.Nombre_producto,
      descripcion: this.Descripcion,
      precio: parseFloat(this.Precio) || 0,
      estado: this.Estado,
      id_categoria: parseInt(this.Id_categoria) || null,
      id_sucursal: parseInt(this.Id_sucursal) || null,
      nombre_categoria: this.Nombre_categoria,
      nombre_sucursal: this.Nombre_sucursal,
      nombre_empresa: this.Nombre_empresa
    };
  }

  // ✅ MÉTODO MEJORADO - GENERAR URL DE IMAGEN DESDE BASE64
  getImageUrl() {
    if (!this.Imagen) return null;
    
    // Si ya es una URL, devolverla directamente
    if (this.Imagen.startsWith('data:') || this.Imagen.startsWith('http')) {
      return this.Imagen;
    }
    
    // Asumir que es base64 y crear data URL
    return `data:image/jpeg;base64,${this.Imagen}`;
  }

  // ✅ MÉTODO MEJORADO - ESTABLECER IMAGEN DESDE ARCHIVO
  setImageFromFile(file) {
    return new Promise((resolve, reject) => {
      if (!file) {
        this.ImagenFile = null;
        this.Imagen = '';
        resolve();
        return;
      }

      // Validar que sea un archivo de imagen
      if (!file.type.startsWith('image/')) {
        reject(new Error('El archivo debe ser una imagen'));
        return;
      }

      // Validar tamaño (máximo 5MB)
      if (file.size > 5 * 1024 * 1024) {
        reject(new Error('La imagen no debe superar los 5MB'));
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const result = e.target.result;
          const base64 = result.split(',')[1]; // Remover el prefijo data:image/...;base64,
          
          this.Imagen = base64;
          this.ImagenFile = file;
          
          console.log('✅ Imagen procesada correctamente:');
          console.log('  - Archivo:', file.name, file.size, 'bytes');
          console.log('  - Base64 length:', base64.length);
          console.log('  - ImagenFile establecido:', !!this.ImagenFile);
          
          resolve(base64);
        } catch (error) {
          console.error('❌ Error procesando imagen:', error);
          reject(error);
        }
      };
      
      reader.onerror = (error) => {
        console.error('❌ Error leyendo archivo:', error);
        reject(new Error('Error al leer el archivo'));
      };
      
      reader.readAsDataURL(file);
    });
  }

  // ✅ MÉTODO PARA LIMPIAR IMAGEN
  clearImage() {
    this.Imagen = '';
    this.ImagenFile = null;
  }

  // ✅ MÉTODO PARA VERIFICAR SI TIENE IMAGEN
  hasImage() {
    return !!(this.Imagen && this.Imagen.length > 0);
  }

  // ✅ MÉTODO PARA OBTENER TAMAÑO DE IMAGEN EN MB
  getImageSizeInMB() {
    if (!this.Imagen) return 0;
    
    try {
      const base64Data = this.Imagen.replace(/^data:image\/[^;]+;base64,/, '');
      const decoded = atob(base64Data);
      return (decoded.length / (1024 * 1024)).toFixed(2);
    } catch (error) {
      console.error('Error calculando tamaño de imagen:', error);
      return 0;
    }
  }

  // ✅ MÉTODO PARA CLONAR EL PRODUCTO
  clone() {
    return new Productos({
      Id_producto: this.Id_producto,
      Nombre_producto: this.Nombre_producto,
      Descripcion: this.Descripcion,
      Precio: this.Precio,
      Imagen: this.Imagen,
      ImagenFile: this.ImagenFile,
      Estado: this.Estado,
      Id_categoria: this.Id_categoria,
      Id_sucursal: this.Id_sucursal,
      Nombre_categoria: this.Nombre_categoria,
      Nombre_sucursal: this.Nombre_sucursal,
      Nombre_empresa: this.Nombre_empresa,
      Fecha: this.Fecha,
      Hora: this.Hora
    });
  }

  // ✅ MÉTODO PARA ACTUALIZAR DATOS (útil para ediciones)
  updateData(newData) {
    const updatedProduct = new Productos(newData);
    
    // Preservar la imagen actual si no se proporciona nueva imagen
    if (!updatedProduct.Imagen && this.Imagen) {
      updatedProduct.Imagen = this.Imagen;
      updatedProduct.ImagenFile = this.ImagenFile;
    }
    
    return updatedProduct;
  }
}